export default __webpack_public_path__ + "static/media/collapse.681161f8.svg";